import React from 'react';
import katharsis from "../../assets/coverart/Katharsis.png"
import are from "../../assets/coverart/ARE.jpg"
import fuehler from "../../assets/coverart/Fühler_Cover.jpg"
import els from "../../assets/coverart/Els.jpg"
import paradies from "../../assets/coverart/paradies.jpg"
import maschinen from "../../assets/coverart/Maschinen.jpg"
import vgmn from "../../assets/coverart/Vergissmeinnicht.jpg"
import azu from "../../assets/coverart/azu.jpg"
import bka from "../../assets/coverart/bka.jpg"
import transformation from "../../assets/coverart/Transformation.jpg"
import tiefseetauchen from "../../assets/coverart/Tiefseetauchen.jpg"





import './Releases.css';


/** Add new releases by dropping one more object in this list */
const releases = [
  {
    img: tiefseetauchen,
    alt: "Tiefseetauchen Coverart",
    href: "https://www.regentaenzer.com/tiefseetauchen",
    title: "Tiefseetauchen",
    description: "Was passiert, wenn du nicht an der Oberfläche bleibst, sondern dich traust, dir selbst mal wirklich zuzuhören?"
  },
      {
  img: transformation,
    alt: "Transformation Coverart",
    href: "https://www.regentaenzer.com/transformation",
    title: "Transformation",
    description: "Manchmal bedeutet Transformation nicht, jemand Neues zu werden, sondern aufzuhören, jemand anderes zu sein."
  },
    {
  img: bka,
    alt: "Blickkontaktabbruch Coverart",
    href: "https://www.regentaenzer.com/bka",
    title: "Blickkontaktabbruch",
    description: "Vielleicht bist du mutiger geworden, oder direkter. Vielleicht freier. Da gibt's Menschen, die sich mit dir freuen. Und dann gibt's die, die sich wohler fühlen würden, wenn ihr gemeinsam ängstlich bleibt."
  },
  {
  img: azu,
    alt: "Anleitung zur Unsichtbarkeit Coverart",
    href: "https://www.regentaenzer.com/azu",
    title: "Anleitung zur Unsichtbarkeit",
    description: "Was passiert, wenn du dich jahrelang zurücknimmst und perfekt funktionierst: Du hast niemanden gestört – aber gesehen hat's auch keiner. Mühe umsonst."
  },
         {
    img: vgmn,
    alt: "Vergissmeinnischt Coverart",
    href: "https://www.regentaenzer.com/vergissmeinnicht",
    title: "Vergissmeinnicht",
    description: "Ein innerer Monolog über das Wandern in selbstgebauten Labirynthen und die Frage, wie das wäre, wenn man all die hart erarbeitete Selbstoptimierung einfach über Bord wirft."
  },
       {
    img: maschinen,
    alt: "Maschinen Coverart",
    href: "https://www.regentaenzer.com/maschinen",
    title: "Maschinen",
    description: "Solange du tanzt wie du selbst, haben wir noch eine Chance."
  },
       {
    img: paradies,
    alt: "Paradies Coverart",
    href: "https://www.regentaenzer.com/paradies",
    title: "Ein neues Paradies, oder: Die Bäume waren mal Zäune.",
    description: "Wann haben wir eigentlich beschlossen, dass uns die Bäume gehören? Und warum rennen alle so schnell, und wohin?"
  },
     {
    img: els,
    alt: "Endlosschleifen Coverart",
    href: "https://www.regentaenzer.com/endlosschleifen",
    title: "Endlosschleifen",
    description: "Es gibt Geschichten, die andere über dich erzählen, bis du sie glaubst, und Geschichten, die du selbst erfunden hast. Aber wer bist du, ohne all die Geschichten-Schichten?"
  },
   {
    img: fuehler,
    alt: "Fühler Coverart",
    href: "https://www.regentaenzer.com/fuehler",
    title: "Fühler",
    description: "„Fühler“ ist ein Song für stille Beobachter:innen, die an vielen Orten ein bisschen und nirgends ganz dazugehören. Fühlst du was, was ich nicht fühl?"
  },
  {
    img: are,
    alt: "ARE cover art",
    href: "https://www.regentaenzer.com/abwaertsradeleuphorie",
    title: "Abwärtsradeleuphorie",
    description: "Das Setting: Abends Fahrradfahren am Übergang Stadtzentrum zum Stadtrand, vom Tag zur Nacht, vom Winter zum Frühling. Oberflächen werden brüchig und Geschichten werden sichtbar. Das Gefühl: Du bist melancholich, weil’s gerade so schön ist, dass das unmöglich so bleiben kann."
  },
  {
    img: katharsis,
    alt: "Katharsis cover art",
    href: "https://www.regentaenzer.com/katharsis",
    title: "Katharsis",
    description: "POV: Du realisierst mit Ende 20, dass alle deine Gefühle dir einfach nur was sagen wollten, und plötzlich sind die unbequemen gar nicht mehr so schlimm. Und wenn du ehrlich bist, hast du eigentlich hast du immer schon am liebsten zu traurigen Songs getanzt."
  },
  // { img, alt, href, title }  ← just add more objects here
];

export const Releases = () => (
  <section id="releases">
    <div className="text-card-container">
      <h1 className="section-header">Releases</h1>

      <div className="cover-gallery">
        {releases.map(({ img, alt, href, title, description }) => (
          /* the whole card is now the link */
          <a
            key={title}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="cover-card"
          >
            <div className="cover-art-small">
              <img src={img} alt={alt} />
            </div>

            {/* small gap below the image */}
            <p className="mt-3 mb-1"><b>{title}</b></p>
            <small>{description}</small>
          </a>
        ))}
      </div>
    </div>
  </section>
);